import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ShieldX, FileQuestion, ServerCrash, ArrowLeft, RefreshCw } from 'lucide-react';

const ErrorLayout = ({ icon: Icon, iconColor, title, subtitle, children }) => (
  <div className="min-h-screen bg-[#0f1d32] flex items-center justify-center p-4">
    <div className="text-center max-w-md">
      <div className={`w-20 h-20 rounded-2xl ${iconColor} flex items-center justify-center mx-auto mb-6`}>
        <Icon className="w-10 h-10 text-white" />
      </div>
      <h1 className="text-3xl font-manrope font-bold text-white mb-2">{title}</h1>
      <p className="text-[var(--crm-text-secondary)] mb-8">{subtitle}</p>
      {children}
    </div>
  </div>
);

export const ForbiddenPage = () => {
  const navigate = useNavigate();
  return (
    <ErrorLayout icon={ShieldX} iconColor="bg-red-500/20" title="Brak dostępu" subtitle="Nie masz uprawnień do tej strony.">
      <button onClick={() => navigate('/')} data-testid="error-go-dashboard"
        className="bg-[#FF6B35] hover:bg-[#e55a2a] text-white px-6 py-2.5 rounded-lg font-medium transition-colors flex items-center gap-2 mx-auto">
        <ArrowLeft className="w-4 h-4" />Wróć do Dashboard
      </button>
    </ErrorLayout>
  );
};

export const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <ErrorLayout icon={FileQuestion} iconColor="bg-amber-500/20" title="Strona nie istnieje" subtitle="Nie znaleziono strony, której szukasz.">
      <button onClick={() => navigate('/')} data-testid="error-go-dashboard"
        className="bg-[#FF6B35] hover:bg-[#e55a2a] text-white px-6 py-2.5 rounded-lg font-medium transition-colors flex items-center gap-2 mx-auto">
        <ArrowLeft className="w-4 h-4" />Wróć do Dashboard
      </button>
    </ErrorLayout>
  );
};

export const ServerErrorPage = () => {
  const navigate = useNavigate();
  return (
    <ErrorLayout icon={ServerCrash} iconColor="bg-purple-500/20" title="Coś poszło nie tak" subtitle="Spróbuj ponownie za chwilę.">
      <div className="flex items-center gap-3 justify-center">
        <button onClick={() => window.location.reload()} data-testid="error-refresh"
          className="bg-[var(--crm-bg-btn-secondary)] hover:bg-[var(--crm-bg-btn-secondary-hover)] text-white px-5 py-2.5 rounded-lg font-medium transition-colors flex items-center gap-2">
          <RefreshCw className="w-4 h-4" />Odśwież stronę
        </button>
        <button onClick={() => navigate('/')} data-testid="error-go-dashboard"
          className="bg-[#FF6B35] hover:bg-[#e55a2a] text-white px-5 py-2.5 rounded-lg font-medium transition-colors flex items-center gap-2">
          <ArrowLeft className="w-4 h-4" />Dashboard
        </button>
      </div>
    </ErrorLayout>
  );
};
